import { FC, useEffect, useState } from 'react'
import { Button, Grid, IconButton, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthStore } from '../../hooks';
import { useASTStore } from '../../hooks/useAST';
import { CustomBackdrop } from '../../components/common/CustomBackdrop/CustomBackdrop';
import { ApiStatus } from '../../types/api/status';
import { AST } from '../../types/slices/ASTType';
import { RoutesMap } from '../../types';
import { Role } from '../../types/roles/roleTypes';
import { ModalConfirm } from '../../components/common/ModalConfirm/ModalConfirm';
import { ASTSignatureModal } from './ASTSignatureModal';

const ASTSignature: FC = () => {
    const navigate = useNavigate()
    const { user } = useAuthStore()
    const params = useParams()
    const { id } = params
    const { status: ASTstatus, getOneASTstore, setSelectedAST, getASTPDFstore } = useASTStore();
    const [pdf, setPDF] = useState<any>(null)
    const [idAST, setIdAST] = useState<number | undefined>(0)
    const [showModalFirm, setShowModalFirm] = useState<boolean>(false)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [signed, setSigned] = useState<boolean>(false)
    const userRole: Role | any = user.userType;

    useEffect(() => {
        setLocalData()
    }, [])

    const setLocalData = async () => {
        const idAst: any = id
        setIdAST(idAst)
        const ASTselect: AST = await getOneASTstore(idAst)
        setSelectedAST(ASTselect)
        if (ASTselect && Object.entries(ASTselect).length > 0) {
            if (ASTselect.status_supervisor === "1") {
                setSigned(true)
            } else if (userRole === Role.MECHANIC && ASTselect.signing_ast?.find((users: any) => users.rut === user.rut)) {
                setSigned(true)
            }
            await showPDF(idAst)
        }
    }

    const showPDF = async (idAst: number) => {
        const pdf = await getASTPDFstore(idAst)
        const blob = new Blob([pdf], { type: 'application/pdf' })
        const bloblURL = URL.createObjectURL(blob)
        setPDF(bloblURL)
    }

    const handleBack = () => {
        if ((userRole === Role.MECHANIC || userRole === Role.SUPERVISOR) && !signed) {
            setShowModalConfirm(true)
        } else {
            navigate({ pathname: RoutesMap.AST_LIST })
        }
    }

    const onConfirmBack = async () => {
        navigate({ pathname: RoutesMap.AST_LIST })
    }

    const modalSignature = () => {
        setShowModalFirm(true)
    }

    return (
        <Grid container>
            {ASTstatus === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            <Grid item xs={12} display='flex' alignItems='center' sx={{ marginLeft: '-25px' }}>
                <IconButton size="small" color="primary" aria-label="view" onClick={() => handleBack()}>
                    <ArrowBackIcon fontSize='small' />
                </IconButton>
                <Typography>Volver</Typography>
            </Grid>
            <Grid item container sx={{ alignItems: "center", display: "flex", justifyContent: "center", flexWrap: "wrap", marginBottom: "10px" }}>
                <Typography variant="h6" component="h1" gutterBottom color="#808080" className="tittle" sx={{ mt: 1, ml: 1, fontWeight: 600 }}>
                    ANÁLISIS DE SEGURIDAD EN EL TRABAJO (AST)
                </Typography>
            </Grid>
            {
                !signed && (userRole === Role.MECHANIC || userRole === Role.SUPERVISOR) && (
                    <Grid item xs={12} sx={{ textAlign: "right" }}>
                        <Button
                            onClick={() => modalSignature()}
                            sx={{ border: "solid 1px #73B2FF", m: "10px", color: "#73B2FF", width: '150px', "&:hover": { bgcolor: "#73B2FF", color: "#fff" } }}
                        >
                            FIRMAR
                        </Button>
                    </Grid>
                )
            }
            <Grid container style={{ overflow: 'hidden !important', height: '100%', alignItems: 'center', textAlign: 'center' }}>
                <iframe title="pdfVer" src={pdf} id="pdfVer" height="1000px" width="100%"></iframe>
            </Grid>
            {
                showModalFirm && (
                    <ASTSignatureModal
                        open={showModalFirm}
                        closeModal={() => setShowModalFirm(false)}
                        idAst={idAST}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false) }}
                        onCancel={() => { setShowModalConfirm(false) }}
                        onConfirm={onConfirmBack}
                        title="¿Está seguro de salir?"
                        text="La pauta de revisión aún no ha sido firmada."
                    />
                )
            }
        </Grid>
    )
}

export default ASTSignature